export const UxStaff = 'ux:staff';
export const UxAdmin = 'ux:admin';
export const FormDebug = 'form:debug';
